import { combineReducers } from "@reduxjs/toolkit";

import { tdsApi } from "../../api";
import appStateReducer from "../slices/appSlice";
import newTopologyReducer from "../slices/newTopologySlice";
import taskPanelReducer from "../slices/taskPanelSlice";
import { machineTasks, topologies, vsRemoteDebuggerPort } from "./myTopologiesReducer";
import {
  cloudTypesDefaultClassic,
  customFormData,
  duplicateThresholdTopologies,
  topologyTypes,
  userRegion,
} from "./newTopologyReducer";
import { queueRequests, queueRequestsSelected } from "./queueRequestsReducer";
import { propertyBag, taskLogs } from "./TaskListReducer";

const rootReducer = combineReducers({
  appState: appStateReducer,
  taskPanel: taskPanelReducer,
  newTopology: newTopologyReducer,
  topologies,
  machineTasks,
  taskLogs,
  propertyBag,
  vsRemoteDebuggerPort,
  topologyTypes,
  cloudTypesDefaultClassic,
  customFormData,
  queueRequests,
  queueRequestsSelected,
  duplicateThresholdTopologies,
  userRegion,
  [tdsApi.reducerPath]: tdsApi.reducer,
});

export default rootReducer;
